export default __webpack_public_path__ + "static/compareItemImg5-6495f38adeb33ec35fc360020edf145e.png";